module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-epigraph element-without-heading",
    attrs: {
      "id": "epigraph-2"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('i', [_vm._v("This story appeared in the June 2016 issue of ")]), _vm._v("Asimov’s Science Fiction"), _c('i', [_vm._v(" magazine. I was working on my First Contact novel, ")]), _vm._v("Alien Morning"), _c('i', [_vm._v(" (Tor, 2016), at the time and gave serious consideration to plugging it into that novel. It seemed to stand so well on its own, however, that I ultimately decided to give the protagonist her own story. One of these days I’m going to write another story about Emma when she’s a little older and heading out for some new adventures.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-635c24ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introductiontorambunctious.vue
// module id = 87
// module chunks = 0